export default "__VITE_ASSET__D$I04cPv__"